import type { Utilities } from 'core/domains';
import config from 'config';

const { bff } = config;

/**
 * Interpolates the given resource key with the given parameters.
 *
 */
export function getRequestURL(
  endpoint: string | ((options: Utilities.PlainObject<string>) => string),
  payload: Utilities.PlainObject<string>,
) {
  if (typeof endpoint === 'string') {
    const removedSlashEndpoint = endpoint.startsWith('/') ? endpoint.split('/')[1] : endpoint;
    return new URL(removedSlashEndpoint, bff.baseUrl).href;
  }
  return new URL(endpoint(payload), bff.baseUrl).href;
}
